import { render, staticRenderFns } from "./Commodato.vue?vue&type=template&id=2406c388&scoped=true"
import script from "./Commodato.vue?vue&type=script&lang=js"
export * from "./Commodato.vue?vue&type=script&lang=js"
import style0 from "./Commodato.vue?vue&type=style&index=0&id=2406c388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2406c388",
  null
  
)

export default component.exports